// extracted by mini-css-extract-plugin
export default {"PasswordResetEmail":"yp_a bhi_qr bhi_a bhi_w bhi_ea bhi_tg","PasswordResetEmail__title":"yp_b bhi_vn bhi_re bhi_uy","PasswordResetEmail__subtitle":"yp_c bhi_uy"};